const boatTypes = [
  {
    key: 'all',
    label: 'All',
    default: true
  },
  {
    key: 'Human-PoweredBoats',
    label: 'Human-Powered Boats'
  },
  {
    key: 'MotorizedBoats',
    label: 'Motorized Boats'
  }

]
export default boatTypes
